export default __webpack_public_path__ + "static/media/change-status-success-icon.abe4cd44.svg";